module.exports = __webpack_public_path__ + "img/icon_24_setting.41ba3e99.svg";